module.exports = __webpack_public_path__ + "static/media/C_Q.33def7b1.png";